import React from 'react'
import './index.css'
interface Props {
  url: string;
  height: number;
  width: number;
  error: boolean;
}

const IFrame =({ url, height, width, error }: Props) => {
  return (
    <div style={{ height }}>
      <iframe 
        title='frame'
        src={url}
        style={{
          maxHeight: height-15,
          maxWidth: width-40, 
          position: 'absolute',
          display: 'block',
        }}  
        height="100%" 
        width='96%'
        className={error ? 'iframe-error' : ''}  
      />
    </div>
  )
}

export default IFrame